import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import {
  setUserVideoAutoPlayStatus,
  setUserVideoPlayerStatus
} from '../../../common/actions/user/preference'
import { IRootState } from '../../../common/reducers'
import VideoControls from './videoControls'

interface IStateProps {
  muted: boolean
  autoplay: boolean
}

interface IDispatchProps {
  enableAutoplay: (mute: boolean) => any
  onMute: () => any
  onUnmute: () => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { user: { preferences } } = state

  return {
    muted: preferences.searchVideoMuted,
    autoplay: preferences.searchVideoAutoPlay
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>) => {
  return {
    onMute: () => dispatch(setUserVideoPlayerStatus(true)),
    onUnmute: () => dispatch(setUserVideoPlayerStatus(false)),
    enableAutoplay: (muted: boolean) => {
      dispatch(setUserVideoAutoPlayStatus(true))
      dispatch(setUserVideoPlayerStatus(!muted))
    }
  }
}

const VideoControlsContainer = connect<
  IStateProps,
  IDispatchProps,
  void,
  IRootState
>(mapStateToProps, mapDispatchToProps)(VideoControls)

export default VideoControlsContainer
